<script>
import MethodButtonBase from './MethodButtonBase';
import IconIdCard from '../../assets/svg/id-card.svg';
export default {
  name: 'MobileIdButton',
  components: {
    MethodButtonBase,
    IconIdCard,
  },
}
</script>

<template>
  <MethodButtonBase>
    <template v-slot:slot1>
      <IconIdCard :class="$style.icon" />
    </template>
    <template v-slot:slot2>
      {{ $t('id-card') }}
    </template>
  </MethodButtonBase>
</template>

<style lang="scss" module>
.icon {
  display: block;
  width: 35px;
  height: auto;
  margin-right: 8px;
}
</style>
